import { Reveal } from "./Reveal";
import { steps, categoryTags } from "@/data/site";

export const HowItWorks = () => {
  return (
    <section id="come-funziona" className="bg-linen py-20 sm:py-28" data-testid="how-it-works">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16 sm:mb-24">
          <div>
            <Reveal>
              <p className="font-sans-ui text-[11px] tracking-mega text-ink/40 mb-6">CAPITOLO 02 — IL PROCESSO</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display font-light text-ink text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-3xl">
                Dal nostro catalogo al tuo cliente.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="font-sans-ui text-sm text-ink/60 lg:text-right max-w-xs">
              Cinque passaggi.<br />Nessun magazzino da costruire.
            </p>
          </Reveal>
        </div>

        <div className="border-t hairline">
          {steps.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.04}>
              <div className="grid grid-cols-1 md:grid-cols-[140px_1fr] lg:grid-cols-[180px_1fr_1fr] gap-4 md:gap-8 py-10 sm:py-14 border-b hairline group">
                <div className="flex items-baseline gap-4">
                  <span className="font-display text-5xl sm:text-6xl text-ink/25 group-hover:text-ink transition-colors duration-500">{s.num}</span>
                  <span className="font-sans-ui text-[10px] tracking-mega text-ink/50 pt-2">{s.key}</span>
                </div>
                <div>
                  <h3 className="font-display text-3xl sm:text-4xl text-ink leading-tight mb-4">{s.title}</h3>
                  <p className="font-sans-ui text-sm sm:text-base text-ink/70 leading-relaxed max-w-lg">{s.body}</p>

                  {s.num === "01" && (
                    <div className="flex flex-wrap gap-2 mt-6 max-w-lg">
                      {categoryTags.map((c, ci) => (
                        <span key={c} data-testid={`category-tag-${ci + 1}`} className="font-sans-ui text-[11px] tracking-wide text-ink/60 border hairline px-3 py-1.5">{c}</span>
                      ))}
                    </div>
                  )}
                  {s.list && (
                    <ul className="mt-6 grid grid-cols-2 gap-y-2 gap-x-6 max-w-md font-sans-ui text-sm text-ink/80">
                      {s.list.map((li) => <li key={li} className="flex gap-2"><span className="text-goldtan">—</span>{li}</li>)}
                    </ul>
                  )}
                </div>
                <div className="lg:flex items-end justify-end hidden">
                  {s.quote && <p className="font-display italic text-xl xl:text-2xl text-ink/80 text-right max-w-xs leading-snug">{s.quote}</p>}
                </div>
                {s.quote && (
                  <p className="lg:hidden font-display italic text-xl text-ink/80 leading-snug md:col-start-2">{s.quote}</p>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
